<template>
	<div>
		<!-- <ad-favlists v-if=" getAdVisibility && getLoggedIn "></ad-favlists> -->

		<div class="shop_wrapper">
			<div class="container">
				<div class="row">
					<div class="col-xl-3 col-lg-4 col-md-12">
						<menu-sidebar></menu-sidebar>
					</div>

					<div class="col-xl-9 col-lg-8 col-md-12">    
						<router-view></router-view>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import MenuSidebar from './menus/MenuSidebar.vue';
	import AdFavlists from './helpers/AdFavlists.vue'

	import { mapGetters } from 'vuex'

	export default {
		components: { MenuSidebar, AdFavlists },
	  data () {
	    return {
	      msg: ''
	    }
		},
		computed: {	
      ...mapGetters( ['getAdVisibility', 'getLoggedIn'])
    },
	}
</script>

<style type="text/css">
	.shop_wrapper{ margin-top: 24px;  }
</style>
